"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProofAuthenticity = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importStar(require("react"));

var NFTDataContext_1 = require("../context/NFTDataContext");

var media_urls_1 = require("../constants/media-urls");

var useMediaContext_1 = require("../context/useMediaContext");

var InfoContainer_1 = require("./InfoContainer");

var ProofLink = function ProofLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      styles = _ref.styles;
  return jsx_runtime_1.jsx("a", Object.assign({}, styles, {
    href: href,
    target: "_blank",
    rel: "noreferrer"
  }, {
    children: children
  }), void 0);
};

var ProofAuthenticity = function ProofAuthenticity(_ref2) {
  var className = _ref2.className;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      data = _react_1$useContext.nft.data;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getString = _useMediaContext_1$us.getString,
      getStyles = _useMediaContext_1$us.getStyles,
      networkId = _useMediaContext_1$us.networkId;

  var linkStyles = getStyles("fullProofLink");

  var getContent = function getContent(nft) {
    var _a;

    var infoURL = data && "zoraNFT" in data && ((_a = data === null || data === void 0 ? void 0 : data.zoraNFT) === null || _a === void 0 ? void 0 : _a.contentURI) || (data === null || data === void 0 ? void 0 : data.nft.metadataURI);
    var infoUrlLabelText = (infoURL === null || infoURL === void 0 ? void 0 : infoURL.includes("/ipfs/")) || (infoURL === null || infoURL === void 0 ? void 0 : infoURL.startsWith("ipfs://")) ? "VIEW_IPFS" : "VIEW_METADATA";
    return jsx_runtime_1.jsxs(react_1.default.Fragment, {
      children: [jsx_runtime_1.jsx(ProofLink, Object.assign({
        styles: linkStyles,
        href: "".concat(media_urls_1.VIEW_ETHERSCAN_URL_BASE_BY_NETWORK[networkId]).concat(nft.contract.address, "?a=").concat(nft.tokenId)
      }, {
        children: getString("ETHERSCAN_TXN")
      }), void 0), infoURL && jsx_runtime_1.jsx(ProofLink, Object.assign({
        styles: linkStyles,
        href: infoURL
      }, {
        children: getString(infoUrlLabelText)
      }), void 0), data && "zoraNFT" in data && data.zoraNFT && jsx_runtime_1.jsx(ProofLink, Object.assign({
        styles: linkStyles,
        href: "".concat(media_urls_1.MEDIA_URL_BASE_BY_NETWORK[networkId]).concat(nft.creator, "/").concat(nft.tokenId)
      }, {
        children: getString("VIEW_ZORA")
      }), void 0)]
    }, void 0);
  };

  return jsx_runtime_1.jsx(InfoContainer_1.InfoContainer, Object.assign({
    titleString: "PROOF_AUTHENTICITY",
    bottomPadding: false,
    className: className
  }, {
    children: jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoProofAuthenticityContainer"), {
      children: data && getContent(data.nft)
    }), void 0)
  }), void 0);
};

exports.ProofAuthenticity = ProofAuthenticity;